<!--
 * @Description: 
 * @Author: pzx
 * @Date: 2022-10-17 17:30:13
 * @LastEditors: xgx
 * @LastEditTime: 2023-06-21 15:37:40
-->
<template>
  <div class="table-box">
    <a-table
      :scroll="{ x:'max-content', y:height }"
      :columns="columns"
      :data-source="templateList"
      :row-key="(record) => record.name"
      :pagination="false"
      :locale="locale"
    >
      <template slot="name" slot-scope="text, record">
        <div style="cursor: pointer;" @click="toDirectory(record.allPath, record.name, record.isDir)">
          <span  class="icon-folder-open" v-if="record.isDir"></span>
          <span  class="icon-file-code" v-else></span>&nbsp;
          {{ record.name }}
        </div>
      </template>
      <template slot="action" slot-scope="text, record">
          <div style="display: flex">
              <div class="btnTwo" :style="{  marginRight: !record.isDir ? '20px' : '' }"  v-if="codeData.indexOf('95') != -1 && !record.isDir" @click="editAdmin(record)">编辑</div>
              <div
                v-if="codeData.indexOf('96') != -1"
                @click="open(record)"
                class="btnThree"
                >删除</div
              >
          </div>
      </template>
    </a-table>
    <el-dialog
      title="确认删除文件?"
      :visible.sync="dialogVisibleTwo"
      width="450px"
      custom-class="tips-box"
      top="17%"
    >
      <span>删除系统文件可能导致运行不正常，请谨慎操作！</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleTwo = false">取消</el-button>
        <el-button :loading="deleteShow" type="danger" @click="deleteTemplate">确认删除</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { removeTemplate } from "./template_management.js";
import { message } from "ant-design-vue";
export default {
  data() {
    return {
      dialogVisibleTwo: false,
       locale:{emptyText:<el-empty description="暂无数据"></el-empty>},
      columnItem: {},
      height:0,
      columns: [
        {
          title: "名称",
          dataIndex: "name",
          scopedSlots: { customRender: "name" },
          ellipsis: true,
          customCell: column => {
            return {
              style: {
                'min-width': "320px",
                'max-width': "660px",
              }
          };
        },
        customHeaderCell: column => {
          return {
             style: {
                'min-width': "320px",
                'max-width': "660px",
              }
          };
        }
        },
        {
          title: "文件大小",
          dataIndex: "fileSize",
           ellipsis: true,
          width: 120,
        },
        {
          title: "最后修改时间",
          dataIndex: "lastModified",
           ellipsis: true,
          width: 200,
        },
        {
          title: "操作",
          dataIndex: "operation",
          scopedSlots: { customRender: "action" },
          fixed: "right",
          width: 174,
        },
      ],
      codeData:[],
      deleteShow:false,
    };
  },
  props: {
    templateList: {
      type: Array,
      default: [],
    },
    directoryPath:{
        type:String,
        default:''
    }
  },
  mounted(){
    this.height = document.documentElement.clientHeight - 400;
                        window.onresize = () => {
                        return (() => {
                            this.height = document.documentElement.clientHeight - 400;
                        })();
                        };
     this.codeData = JSON.parse(sessionStorage.getItem('menuData'))
  },
  methods: {
    editAdmin(item) {
      this.$emit("editAdmin", 2, item);
    },
    open(item) {
      this.dialogVisibleTwo = true;
      this.columnItem = item;
    },
    toDirectory(path, name, isDir) {
      if (!isDir) {
        return;
      }
      this.$emit("editDirectoryPath", { name: name, path: path });
    },
    deleteTemplate() {
      const _this = this;
      this.deleteShow = true;
      let reqData = {
        path: _this.columnItem.allPath,
        type: _this.columnItem.isDir ? 1 : 0,
      };
      removeTemplate(reqData).then((res) => {
        if (res.code == 0) {
          this.columnItem = {};
          message.success(res.msg);
          this.$emit("refresh",{path:_this.directoryPath});
          this.dialogVisibleTwo = false;
        }
        this.deleteShow = false;
      });
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .el-table__body {
  color: #000;
  font-weight: 500;
}
/deep/ .has-gutter {
  color: #000;
  font-weight: 800;
}
/deep/ .el-table__header {
  th {
    background: #f7f7f7 !important;
    height: 60px;
  }
}
.sort {
  display: flex;
  border: solid 1px #dcdfe6;
  width: 90px;
  border-radius: 5px;
}
.sort-box {
  width: 30px;
  height: 30px;
  background: #f5f7fa;
  text-align: center;
  line-height: 30px;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  border-right: solid 1px #dcdfe6;
}
.sort-box-two {
  width: 30px;
  height: 30px;
  background: #f5f7fa;
  text-align: center;
  line-height: 30px;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  border-left: solid 1px #dcdfe6;
}
.table-box {
  padding: 24px;
}
/deep/ .el-table {
  border: solid 1px #dcdfe6;
  border-radius: 5px;
  border-bottom: none;
}
/deep/ .el-dialog {
  font-weight: 600;
}
/deep/ .el-dialog__body {
  color: #909399;
  font-weight: 400;
}
/deep/ .el-dialog__close {
  color: #000;
  font-weight: 600;
  font-size: 20px;
}
/deep/ .el-dialog__body {
  padding-top: 15px;
}
/deep/ .ant-table {
  border: solid 1px #f1f1f1;
  border-bottom: none;
  border-radius: 5px;
  color: rgba(255, 255, 255, 1);
}
.delete-input {
  margin-top: 24px;
}
/deep/ .el-dialog__footer {
  padding-top: 0px;
}
/deep/ input::-webkit-input-placeholder {
  color: #415058;
}
/deep/ .el-table {
  border: solid 1px #dcdfe6;
  border-radius: 5px;
  border-bottom: none;
}
/deep/ .el-icon-arrow-right {
  font-size: 18px;
  color: #a9aab1;
}

/deep/ .el-table .el-table__expand-icon {
  .el-icon-arrow-right:before {
    content: "\e791";
  }
}
.btnTwo {
  border-radius: 3px;
  background-color: rgba(240, 246, 255, 1);
  color: rgba(23, 109, 230, 1);
  font-size: 12px;
  font-family: Roboto;
  border: 1px solid rgba(23, 109, 230, 1);
  width: 56px;
  height: 28px;
  line-height: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.btnThree {
  width: 56px;
  height: 28px;
  line-height: 16px;
  border-radius: 3px;
  background-color: rgba(255, 242, 242, 1);
  color: rgba(245, 108, 108, 1);
  font-size: 12px;
  text-align: center;
  font-family: Roboto;
  border: 1px solid rgba(245, 108, 108, 1);
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.btnFour {
  width: 56px;
  height: 28px;
  line-height: 16px;
  border-radius: 3px;
  background-color: rgba(244, 244, 245, 1);
  color: rgba(144, 147, 153, 1);
  font-size: 12px;
  text-align: center;
  font-family: Roboto;
  border: 1px solid rgba(211, 212, 214, 1);
  display: flex;
  justify-content: center;
  align-items: center;
}
/deep/ .ant-table-fixed-right{
    border-left: 1px solid rgba(228, 231, 237, 1);
    
}
/deep/ .ant-table-thead > tr > th{
    background-color: rgba(245, 247, 250, 1);
}
/deep/ .ant-table-thead > tr{
   background-color: rgba(245, 247, 250, 1);
}
/deep/ .ant-table-hide-scrollbar{
  background-color: rgba(245, 247, 250, 1);
  
}
/deep/ .ant-table-column-title{
    color: #606266;
}
/deep/ .el-empty__description p{
    color: rgba(16, 16, 16, 1);
    font-size: 16px;
    text-align: left;
    font-family: Roboto-regular;
  }
  /deep/ .el-empty{
    padding: 11px 0px 15px 0px;
  }
  /deep/ .el-empty__description{
    margin-top: 10px;
  }
  /deep/ .ant-table-placeholder{
    border-bottom: none;
  }
  /deep/ .ant-table-tbody > tr > td{
    padding: 9.5px 16px;
    color: #303133;
}
/deep/ .ant-table-thead > tr > th{
   padding: 13px 16px;
}
/deep/ .ant-table-fixed-right .ant-table-tbody > tr > td{
   padding: 9.5px 24px;
}
/deep/ .ant-table-fixed-right .ant-table-thead > tr:first-child > th:last-child{
  padding: 13px 24px;
  
}
/deep/ .ant-table-fixed-left table,.ant-table-fixed-right table{
    width: min-content;
    }
    /deep/ .ant-table-row-cell-ellipsis {
      max-width: 1px !important;
      overflow: hidden !important;
      white-space: nowrap !important;
      -o-text-overflow: ellipsis !important;
      text-overflow: ellipsis !important;
  }
  /deep/ .ant-table-placeholder{
    border-bottom: none;
  }
   /deep/ tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td, .ant-table-tbody > tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td, .ant-table-thead > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td, .ant-table-tbody > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td {
    background:#fafafa !important;
  }
  /deep/ tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td{
    background:#fafafa !important;
  }
</style>